import React from "react";
import { Link } from "gatsby";
import { regions } from "./regions/RegionsList";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-6xl mx-auto px-4 py-8 sm:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <Link to="/" className="block">
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
                CRJMC.net
              </h3>
            </Link>
            <p className="text-xs sm:text-sm text-gray-400">
              Providing innovative solutions for your security needs.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/renewal-discount"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  Renewal Discount
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-2">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
              Services
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/ontario"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  CRJMC in Ontario
                </Link>
              </li>
              <li>
                <Link
                  to="/ontario/real-estate-agents"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  CRJMC for Real Estate Agents
                </Link>
              </li>
              <li>
                <Link
                  to="/ontario/tow-operators"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  CRJMC for Tow Operators
                </Link>
              </li>
              <li>
                <Link
                  to="/ontario/security-guards"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  CRJMC for Security Guards
                </Link>
              </li>
              <li>
                <Link
                  to="/ontario/private-investigators"
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                >
                  CRJMC for Private Investigators
                </Link>
              </li>
            </ul>
          </div>

          {/* Ontario Regions */}
          <div className="md:col-span-4">
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
              Ontario Regions
            </h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {regions.map((region) => (
                <Link
                  key={region.name}
                  to={`/ontario/${region.name.toLowerCase().replace(" ", "-")}`}
                  className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                  title={`CRJMC in ${region.name} - ${region.description}`}
                >
                  {region.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Blog and Legal */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
                Blog
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/post/getting-a-crjmc-in-ontario-a-complete-guide-2025/"
                    className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                  >
                    CRJMC Guide 2025
                  </Link>
                </li>
                <li>
                  <Link
                    to="/post/complete-guide-to-ontario-security-license/"
                    className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                  >
                    Security License Guide 2025
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
                Legal
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/privacy-policy"
                    className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-of-service"
                    className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
                  >
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-center text-xs sm:text-sm text-gray-400">
              © {new Date().getFullYear()} CRJMC.net. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link
                to="/contact"
                className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400"
              >
                support@crjmc.net
              </Link>
              <a
                href="https://facebook.com/CRJMCnet"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-emerald-400"
                aria-label="Follow us on Facebook"
              >
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a
                href="https://x.com/CRJMC_net"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-emerald-400"
                aria-label="Follow us on X (formerly Twitter)"
              >
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
